import * as React from "react";

import "./help-menu.scss";

import {faQuestionCircle}   from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import {css, cx}            from "emotion";
import {rgba}               from "polished";
import {createElement as h} from "react";

import {AnyAction}      from "@Common/react/any-action";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {Responsive}     from "@Common/ui-components/responsive";

import {InternalLink} from "@Xpresso/routes/common/components/internal-link";

import {estTextWidth} from "../../../../../../common/est-text-width";
import {getAbsLink}   from "../../../../../common/get-abs-link";

export const helpMenu = ({menu, open, navBlock}) => cs(
    consumeContext("themeScheme"),
    ({}, next) => h(AnyAction, {
        disabled: !open.value,
        action: () => open.onChange(null),
        next,
    }),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            lg: 1920,
        },
        next,
    }}/>],
    ({themeScheme, responsive}) => (
        <div
            className={cx("help-menu help-menu-57ru6", css`
                color: ${themeScheme.xpresso.menuTextColor};
            `)}
            onMouseEnter={(e) => {
                // @ts-ignore
                open.onChange(e.target.getBoundingClientRect());
                e.stopPropagation();
            }}
            onMouseLeave={() => {
                if (open.value) {
                    open.onChange(null);
                }
            }}
        >
            {menu && menu.type === "internalUrl" ? (
                InternalLink({
                    to: menu.link,
                    className: "toggle-ov1",
                    "xd-qa-type": "icon",
                    "xd-qa-name": "help",
                    navBlock,
                    children: <FontAwesomeIcon icon={faQuestionCircle}/>,
                })
            ) : (
                <a
                    className="toggle-ov1"
                    xd-qa-type="icon"
                    xd-qa-name="help"
                    href={menu?.link && getAbsLink(menu.link)}
                    onClick={async (e) => {
                        if (menu?.link) {
                            e.preventDefault();
                            if (await navBlock?.block() === true) {
                                return;
                            }
                            window.location.href = getAbsLink(menu.link);
                        } else {
                            // @ts-ignore
                            open.onChange(open.value ? null : e.target.getBoundingClientRect());
                            e.stopPropagation();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faQuestionCircle}/>
                </a> 
            )}
            {open.value && (
                <div
                    className="dropdown-ov1"
                    style={{
                        top : open.value.bottom,
                        right: window.innerWidth - open.value.right,
                        background: rgba(themeScheme.xpresso.menuBackgroundColor, 0.98),
                        width: (
                            (Math.max(...menu && menu.subMenu && menu.subMenu.map((m) => estTextWidth(m.linkLabel, 400, 15.4))||[], 100) + 60)
                            *
                            (responsive.lt("lg") ? 1 : 1/0.7)
                        ),
                    }}
                >
                    <div className="content-ov1">
                        <div className="items-ov1">
                            {menu?.subMenu?.map((m,i) => cs(
                                keyed(i),
                                () => {
                                    const className = css`
                                        color: ${themeScheme.xpresso.menuTextColor} !important;
                                        &:hover {
                                            color: white;
                                        }
                                    `;

                                    return (m.type === "url" || m.type === "tel") ? (
                                        <a {...{
                                            className: cx("item-ov1", className),
                                            href: getAbsLink(m.link),
                                            "xd-qa-type": "link",
                                            "xd-qa-name": m.linkLabel,
                                            ...m.link === "s/custom-quote-request/" && {
                                                target: "_blank"
                                            },
                                            onClick: async (e) => {
                                                e.preventDefault();
                                                if (await navBlock?.block() === true) {
                                                    return;
                                                }
                                                window.location.href = getAbsLink(m.link);
                                            }
                                        }}>
                                            {m.linkLabel}
                                        </a>
                                    ) : m.type === "internalUrl" ? (
                                        InternalLink({
                                            to: m.link,
                                            className: cx("item-ov1", className),
                                            "xd-qa-type": "link",
                                            "xd-qa-name": m.linkLabel,
                                            children: m.linkLabel,
                                            navBlock,
                                        })
                                    ) : m.type !== "email" && cs(
                                        consumeContext("liveChatConfig"),
                                        consumeContext("webchat"),
                                        ({webchat, liveChatConfig}) => liveChatConfig && liveChatConfig.chatEnabled && (
                                            <a {...{
                                                className: cx("item-ov1", className),
                                                onClick: () => {
                                                    webchat.show();
                                                    open.onChange(null);
                                                },
                                                "xd-qa-type": "link",
                                                "xd-qa-name": m.linkLabel
                                            }}>
                                                {m.linkLabel}
                                            </a>
                                        )
                                    );
                                },
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
);
